import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help';

interface Props {
  title: string
}

const Infotip = ({ title }: Props) => {
  return (
    <Tooltip title={title} enterTouchDelay={0}>
      <IconButton size="small" sx={{ p: 0.25, display: 'inline-flex' }}>
        <HelpIcon sx={{ fontSize: '1em' }} />
      </IconButton>
    </Tooltip>
  )
}

export default Infotip